import { render, staticRenderFns } from "./TwitterAnalyticsPublicChart.vue?vue&type=template&id=9b7970da&scoped=true"
import script from "./TwitterAnalyticsPublicChart.vue?vue&type=script&lang=ts"
export * from "./TwitterAnalyticsPublicChart.vue?vue&type=script&lang=ts"
import style0 from "./TwitterAnalyticsPublicChart.vue?vue&type=style&index=0&id=9b7970da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7970da",
  null
  
)

export default component.exports